import clsx from 'clsx'
import CaretLeft from '../icons/Arrows/CaretLeft'
import CaretRight from '../icons/Arrows/CaretRight'
import EllipseIcon from '../icons/Interface/EllipseIcon'

const Carousel = ({
	count,
	index,
	setIndex,
	showCarets = false,
}: {
	count: number
	index: number
	setIndex: (index: number) => void
	showCarets?: boolean
}) => {
	const handlePrevious = () => setIndex((index - 1 + count) % count)
	const handleNext = () => setIndex((index + 1) % count)

	return (
		<div className="flex h-full w-full flex-row items-center justify-center gap-x-4">
			{showCarets && (
				<div
					className="cursor-pointer text-uiPrimaryLight hover:text-textPrimaryLight dark:text-uiPrimaryDark dark:hover:text-textPrimaryDark"
					onClick={handlePrevious}
				>
					<CaretLeft />
				</div>
			)}
			{Array.from({ length: count }).map((_, i) => (
				<div
					className={clsx(
						index === i
							? 'text-textPrimaryLight dark:text-textPrimaryDark'
							: ' cursor-pointer text-uiPrimaryLight hover:text-textPrimaryLight dark:text-uiPrimaryDark dark:hover:text-textPrimaryDark',
						'transition-colors duration-500 ease-in-out',
					)}
					key={i}
					onClick={() => setIndex(i)}
				>
					<EllipseIcon size="xSmall" />
				</div>
			))}
			{showCarets && (
				<div
					className={
						index + 1 === count
							? 'cursor-not-allowed text-textInactiveLight dark:text-textInactiveDark'
							: 'cursor-pointer text-uiPrimaryLight hover:text-textPrimaryLight dark:text-uiPrimaryDark dark:hover:text-textPrimaryDark'
					}
					onClick={handleNext}
				>
					<CaretRight />
				</div>
			)}
		</div>
	)
}

export default Carousel
